/* THE BRAND ALKEMI — alkemi.js */

document.addEventListener('DOMContentLoaded', () => {

  // ── CUSTOM CURSOR ──
  const dot  = document.getElementById('cur-dot');
  const ring = document.getElementById('cur-ring');

  if (dot && ring) {
    let mx = 0, my = 0, rx = 0, ry = 0;

    document.addEventListener('mousemove', e => {
      mx = e.clientX;
      my = e.clientY;
    });

    (function tick() {
      if (dot)  { dot.style.left = mx + 'px'; dot.style.top = my + 'px'; }
      rx += (mx - rx) * 0.12;
      ry += (my - ry) * 0.12;
      if (ring) { ring.style.left = rx + 'px'; ring.style.top = ry + 'px'; }
      requestAnimationFrame(tick);
    })();

    document.querySelectorAll('a, button').forEach(el => {
      el.addEventListener('mouseenter', () => ring.classList.add('expanded'));
      el.addEventListener('mouseleave', () => ring.classList.remove('expanded'));
    });
  }

  // ── STICKY NAV ──
  const header = document.getElementById('alkemi-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 60);
    }, { passive: true });
  }

  // ── SCROLL REVEAL ──
  const revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('visible');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    revealEls.forEach(el => obs.observe(el));
  } else {
    // Fallback for older browsers
    revealEls.forEach(el => el.classList.add('visible'));
  }

  // ── MOBILE NAV ──
  const hamburger = document.querySelector('.nav-hamburger');
  const mobileNav = document.getElementById('mobile-nav');
  const mobileClose = document.querySelector('.mobile-nav-close');

  function openMobileNav() {
    mobileNav.classList.add('open');
    mobileNav.setAttribute('aria-hidden', 'false');
    hamburger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileNav() {
    mobileNav.classList.remove('open');
    mobileNav.setAttribute('aria-hidden', 'true');
    hamburger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', openMobileNav);
    if (mobileClose) mobileClose.addEventListener('click', closeMobileNav);
    document.querySelectorAll('.mobile-nav-links a').forEach(link => {
      link.addEventListener('click', closeMobileNav);
    });
    document.querySelector('.mobile-nav-cta')?.addEventListener('click', closeMobileNav);
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') closeMobileNav();
    });
  }

  // ── EMAIL FORM (basic Shopify-compatible) ──
  const joinForm = document.querySelector('.join-form');
  if (joinForm) {
    joinForm.addEventListener('submit', e => {
      e.preventDefault();
    });

    const btn = joinForm.querySelector('button');
    if (btn) {
      btn.addEventListener('click', () => {
        const input = joinForm.querySelector('input[type="email"]');
        if (input && input.value) {
          btn.textContent = 'Welcome ✦';
          btn.style.background = 'var(--bg)';
          setTimeout(() => {
            btn.textContent = 'Join';
            btn.style.background = 'var(--white)';
            input.value = '';
          }, 3000);
        }
      });
    }
  }

});
